<template>
	<component
		:is="tag"
		:class="[settings.fixedClasses.wrapper, settings.variants[variant].wrapper]"
	>
		<!-- @slot Only <nk-list-item> components should be added here -->
		<slot />
	</component>
</template>

<script setup>
import {provide} from 'vue';
import {defineSettings} from '../composables/component';
const settings = defineSettings('NkList');

const props = defineProps({
	tag: {
		type: String,
		required: false,
		default: 'ul',
	},
	variant: {
		type: String,
		required: false,
		default: 'unordered',
	},
	icon: {
		type: String,
		required: false,
		default: null,
	},
});

provide('props', props);
provide('settings', settings);
</script>
